module.exports = __webpack_public_path__ + "static/media/icon_feather.38d68744.svg";